export default "__VITE_ASSET__pWgFUrG8__"